import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import AthleteScore from "../../../components/athlete-scores/athlete-score";

export default function AthleteCombine() {
  const authUser = useAuthUser();

  return (
    <>
      <div className="flex p-4 bg-gray-100 pb-24 md:pb-20 xl:pb-6 lg:pb-24">
        <div className="w-full">
          {authUser?.user?.id && (
            <AthleteScore
              userId={authUser.user.id}
              showOffers={false}
              showTrackittScore={true}
              showPositionScore={true}
              searchEvent={true}
              showProfile={false}
              showRank={true}
              showLikes={false}
              showCompare={false}
            />
          )}
        </div>
      </div>
    </>
  );
}
